export const en = {
  // Landing page hero section
  hero: {
    // title: 'Smart card life\nthat gets better\n the more you use',
    // title: 'Location-Based\nCard Benefit\nPlatform',
    title: 'User Location-Based\nCard Benefit\nRecommendation\nPlatform Service',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    logoTitle: 'CARDEUK'
  },

  // Circle section
  circle: {
    // title: 'Have many cards but missing out on benefits?'
    // title: 'Do you have too many cards\nbut still miss out on the benefits?'
    title: 'Do you have too many cards\nbut still miss out on benefits?'
  },

  // Benefits section
  benefits: {
    title: {
      // desktop: 'Maximize the hidden benefits of your cards',
      // tablet: 'Maximize the hidden\nbenefits of your cards'
      desktop: 'Unlock your card’s full potential.',
      tablet: 'Unlock your card’s full potential.'
    },
    subtitle: {
      // desktop: 'CARDEUK helps you efficiently manage your cards and discover benefits',
      // mobile: 'CARDEUK helps you efficiently manage\nyour cards and discover benefits'
      desktop: 'CARDEUK helps you manage your cards efficiently and maximize the benefits you can enjoy.',
      mobile: 'CARDEUK helps you manage your cards efficiently and maximize the benefits you can enjoy.'
    },
    cards: [
      {
        title: 'Smart Card Picks',
        text: {
          // desktop: 'Anywhere, anytime, CarDeuk instantly\nrecommends the best card for you',
          // mobile: 'Anywhere, anytime, CarDeuk instantly recommends the best card for you'
          desktop: 'Wherever you are, CARDEUK will\n recommend the optimal card for you right away.',
          mobile: 'Wherever you are, CARDEUK picks the best card instantly.'
        }
      },
      {
        title: 'Maximise Benefits',
        text: {
          // desktop: 'Automatically optimizes various benefits\nlike cashback and discounts',
          // mobile: 'Automatically optimizes various benefits like cashback and discounts'
          // desktop:
          //   'We automatically optimise and\n recommend various benefits such as\n points and discounts.',
          // mobile: 'We automatically optimise and\n recommend various benefits such as\n points and discounts.'
          desktop: 'Automatically optimises points, cashback, and discounts.',
          mobile: 'Automatically optimises points, cashback, and discounts.'
        }
      },
      {
        title: 'Smart Spending',
        text: {
          desktop: 'Create smart spending habits by\nchecking benefits before using cards',
          mobile: 'Create smart spending habits by checking benefits before using cards'
          // desktop:
          //   'Create smart spending habits that\n allow you to enjoy benefits even\n before using your card.',
          // mobile:
          //   'Create smart spending habits that\n allow you to enjoy benefits even\n before using your card.'
          // desktop: 'Check benefits before you pay.',
          // mobile: 'Check benefits before you pay.'
        }
      },
      {
        title: 'Protecting Your Data',
        text: {
          // desktop: 'Manage card benefits without\nexcessive data consent',
          // desktop: 'You can manage card benefits\n without agreeing to too much\n information.',
          // mobile: 'Manage card benefits without excessive data consent'
          // mobile: 'You can manage card benefits\n without agreeing to too much\n information.'
          desktop: 'Manage benefits with minimal data consent.',
          mobile: 'Manage benefits with minimal data consent.'
        }
      }
    ]
  },

  // Reviews section
  reviews: {
    title: 'CARDEUK User Reviews',
    cards: [
      {
        text: `Every time I went to the supermarket, I found it cumbersome\n to search for which card to use for discounts. But CARDEUK tells\n me 'Use this card' when I search for a store, so I no longer\n hesitate at checkout. With the chaos of parenting, this is truly\n a 'service that requires no brainpower', and I'm so grateful.`,
        author: 'Lee, 36 | Working mom | Cards Used: 4'
      },
      {
        text: `Unlike other apps that only show points or spending data,\nCARDEUK recommends the best card to use at each location\n without requiring data linkage — making it an easy, stress-free\n solution for multi-card users and frequent travelers.`,
        author: 'Choi, 39 | Freelancer | Cards Used: 5'
      },
      {
        text: `Before using CARDEUK, I relied on memory to use cards (with good benefits),\n but I realised I was missing out on benefits\n every time. Since using CARDEUK, my unconscious spending has transformed into 'planned spending'.\n It feels like I'm\n controlling myself. I always wanted to save even a little when\n spending, and it has really helped me save.`,
        author: 'Park, 29 | office worker | Cards Used: 3'
      }
    ]
  },

  // QAs section
  qas: {
    title: 'CARDEUK Q&A',
    cards: [
      {
        question: 'How do I use CARDEUK?',
        // answer:
        //   'After signing up for SNS, you can register the type of card you have,\n and then search for destinations or select stores on the map to receive\n optimal card recommendations.'
        answer:
          'Register your cards and get recommendations by searching destinations or selecting stores on the map.'
        // boldAnswer: '\nyou can search for destinations or select stores on the map to get the best card recommendations.'
      },
      {
        question: {
          desktop: 'I want to check card benefits for more stores',
          mobile: 'I want to check card benefits for more stores'
        },
        // answer: 'From franchises to local restaurants,\nwe are preparing to register more stores.'
        answer: 'We are preparing to register more stores, from franchises to local favorites.'
      },
      {
        question: 'Is MyData integration required?',
        answer: 'No, you can easily register and manage your cards without linking MyData.'
        // boldAnswer: 'without MyData connection',
        // answer2: '\nyou can easily register and manage cards.'
      },
      {
        question: "I can't find my card.",
        answer: {
          desktop:
            'Cards currently available for issuance can be registered first; discontinued cards can be added upon customer request',
          tablet:
            'Cards currently available for issuance can be registered first; discontinued cards can be added upon customer request'
        }
      }
    ]
  },

  // Service closure notice modal
  closureNotice: {
    title: 'CARDEUK Service Closure Notice',
    greeting: 'Hello, this is CARDEUK.',
    intro:
      'CARDEUK, which we started in the hope of helping make your card life a little smarter, will be temporarily discontinued after Friday, October 23, 2026.\nWe are sorry that we could not stay with you longer, and we sincerely thank everyone who visited and used CARDEUK.',
    detailTitle: 'Service Closure and Personal Data Deletion',
    details: [
      {label: 'Service end date', value: 'October 23, 2026'},
      {label: 'Services affected', value: 'CARDEUK app and related services'},
      {label: 'Personal data deletion date', value: 'October 23, 2026'}
    ],
    privacy:
      'After the service ends, all personal data we hold will be deleted on October 23, 2026, in accordance with our Privacy Policy.\nHowever, information that we are required to retain under applicable laws will be stored separately for the period those laws specify and then deleted.',
    outro:
      'Thank you for the time you spent with CARDEUK. We hope to return with a service that offers you even better benefits. We wish you happiness always.',
    signature: 'The CARDEUK Team',
    close: 'OK'
  },

  // Footer section
  footer: {
    company: 'SALTMiNE Inc. CEO',
    ceo: 'Yoo Chang-hyun',
    businessNumber: '873-86-01911',
    businessNumberLabel: 'Business Registration Number',
    headOffice: '(12902) 177 Misagangbyeonhangang-ro, Hanam-si, Gyeonggi-do, 3F Hanam Startup Campus #7',
    headOfficeLabel: 'Head Office',
    researchOffice: '(31145) 32 Cheonancheon 4-gil, Seobuk-gu, Cheonan-si, Chungnam, Green Startup Town #501',
    researchOfficeLabel: 'Research Office',
    contact: '070-7799-7410',
    contactLabel: 'Contact',
    copyright: '© 2023. SALTMiNE, Inc. all rights reserved.',
    logoAlt: 'SALTMiNE Logo'
  },

  // Register form translations (from existing kr.js)
  register: {
    required: {
      identifier: 'Please enter a valid ID.',
      password: 'Please enter your password.',
      passwordConfirm: 'Please re-enter your password.',
      name: 'Please enter your name.',
      nickname: 'Please enter a valid nickname.',
      birthDate: 'Please enter your date of birth.',
      phoneNumber: 'Please enter your phone number.',
      email: 'Please enter your email.',
      inputVerifyNumber: 'Please enter the verification code.'
    },

    pattern: {
      identifier: 'Please enter only letters and numbers.',
      password:
        "Please enter at least 8 characters combining uppercase + lowercase + numbers + special characters '@&!%*?&'.",
      name: 'Please enter a valid name.',
      nickname: 'Please enter a valid nickname.',
      phoneNumber: 'Please enter a valid phone number.',
      birthDate: 'Invalid date format (YYYY-MM-DD).',
      email: 'Please enter a valid email.'
    },

    maxLength: {
      identifier: 'Maximum 20 characters allowed.',
      name: 'Name can be up to 10 characters.'
    },

    placeholder: {
      identifier: 'ID',
      password: 'Enter password',
      passwordConfirm: 'Confirm password',
      phoneNumber: 'Enter phone number',
      name: 'Name',
      nickname: 'Nickname',
      birthDate: 'Date of birth (YYYY, MM, DD) - numbers only',
      email: 'Email',
      inputVerifyNumber: 'Enter verification code'
    }
  },

  // Profile change translations
  profileChange: {
    placeholder: {
      oldPassword: 'Enter current password',
      newPassword: 'Enter new password',
      newPasswordConfirm: 'Re-enter new password',
      name: 'Name',
      nickname: 'Nickname',
      birthDate: 'Date of birth (YYYY, MM, DD) - numbers only',
      email: 'Email'
    }
  }
};
